"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _DrupalNestedFlippingTiles = _interopRequireDefault(require("./DrupalNestedFlippingTiles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This file is imported in target configs where the tiles should flip on open
 */
var DrupalKesi2RootFlippingTiles = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalKesi2RootFlippingTiles, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalKesi2RootFlippingTiles);

  function DrupalKesi2RootFlippingTiles(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalKesi2RootFlippingTiles);
    _this = _super.call(this, props, context, props.params.contentPath);
    _this.state = _objectSpread({
      pathArray: DrupalKesi2RootFlippingTiles.getPathArray(props.params.contentPath)
    }, _this.state);
    return _this;
  }

  (0, _createClass2["default"])(DrupalKesi2RootFlippingTiles, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_DrupalNestedFlippingTiles["default"], {
        setTitle: this.props.setTitle,
        setCount: this.props.setCount,
        setScrollBarHidden: this.props.setScrollBarHidden,
        setBackButtonFunc: this.props.setBackButtonFunc,
        contentPathArray: this.state.pathArray,
        setShowFavButton: this.props.setShowFavButton
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var pathArray = DrupalKesi2RootFlippingTiles.getPathArray(props.params.contentPath);
      return {
        pathArray: pathArray
      };
    }
  }, {
    key: "getPathArray",
    value: function getPathArray(path) {
      console.log('path', path);
      return path.split(_KesiConstants.KESI_PATH_DELIMITER);
    }
  }]);
  return DrupalKesi2RootFlippingTiles;
}(_KESI2BasicComponent["default"]);

DrupalKesi2RootFlippingTiles.propTypes = {
  params: _propTypes["default"].shape({
    contentPath: _propTypes["default"].string
  }).isRequired,
  setTitle: _propTypes["default"].func,
  setCount: _propTypes["default"].func,
  setScrollBarHidden: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func,
  setShowFavButton: _propTypes["default"].func,
  showSettingsDialog: _propTypes["default"].func
};
DrupalKesi2RootFlippingTiles.defaultProps = {
  setTitle: function setTitle() {},
  setScrollBarHidden: function setScrollBarHidden() {}
};
var _default = DrupalKesi2RootFlippingTiles;
exports["default"] = _default;